// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search-module--wrapper--Br3ZY","results":"search-module--results--3gdKe","result":"search-module--result--3scb7"};